import europe from './europe.json';
import asia from './asia.json';
import northAmerica from "./north-america.json";
import africa from "./Africa.json";
import southAmerica from "./southAmerica.json";
import oceania from "./oceania.json";
import russia from "./russia.json";




export const continentsMap = {

    "type": "FeatureCollection",
    "features": [
      {
        "type": "Feature",
        "properties": {
          "name": "Europe",
          "region_un": "Europe"
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": europe.features.reduce((acc: any, el: any) => {
            return el.geometry.type === "Polygon"
              ? [...acc, el.geometry.coordinates]
              : [...acc, ...el.geometry.coordinates]
          },[])
        }
      },
      {
        "type": "Feature",
        "properties": {
          "name": "Asia",
          "region_un": "Asia"
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": asia.features.reduce((acc: any, el: any) => {
            return el.geometry.type === "Polygon"
              ? [...acc, el.geometry.coordinates]
                : [...acc, ...el.geometry.coordinates]
          },[])

        }
      },
      {
        "type": "Feature",
        "properties": {
          "name": "America",
          "region_un": "America"
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": northAmerica.features.reduce((acc: any, el: any) => {
            return el.geometry.type === "Polygon"
                ? [...acc, el.geometry.coordinates]
                : [...acc, ...el.geometry.coordinates]
          },[])

        }
      },
      {
        "type": "Feature",
        "properties": {
          "name": "Africa",
          "region_un": "Africa"
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": africa.features.reduce((acc: any, el: any) => {
            return el.geometry.type === "Polygon"
                ? [...acc, el.geometry.coordinates]
                : [...acc, ...el.geometry.coordinates]
          },[])

        }
      },
      {
        "type": "Feature",
        "properties": {
          "name": "South America",
          "region_un": "South America"
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": southAmerica.features.reduce((acc: any, el: any) => {
            return el.geometry.type === "Polygon"
                ? [...acc, el.geometry.coordinates]
                : [...acc, ...el.geometry.coordinates]
          },[])

        }
      },
      {
        "type": "Feature",
        "properties": {
          "name": "Russia",
          "region_un": "Russia"
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": russia.features.reduce((acc: any, el: any) => {
            return el.geometry.type === "Polygon"
                ? [...acc, el.geometry.coordinates]
                : [...acc, ...el.geometry.coordinates]
          },[])

        }
      },
      {
        "type": "Feature",
        "properties": {
          "name": "Oceania",
          "region_un": "Oceania"
        },
        "geometry": {
          "type": "MultiPolygon",
          "coordinates": oceania.features.reduce((acc: any, el: any) => {
            return el.geometry.type === "Polygon"
                ? [...acc, el.geometry.coordinates]
                : [...acc, ...el.geometry.coordinates]
          },[])

        }
      }
      ]
}



export default continentsMap;